import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Lightbulb } from "@faire/web/slate/icons/foundation/Lightbulb";
import React from "react";
export var useHowFaireWorksBrandNodes = function useHowFaireWorksBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    HowFaireWorks: {
      id: "HowFaireWorks",
      label: strictLocalize({
        id: "VX1YoC",
        defaultMessage: [{
          "type": 0,
          "value": "How Faire works"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Lightbulb, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      articles: [articles.FaireDirect.FAIRE_DIRECT, articles.FaireDirect.EMAIL_AUTOMATIONS, articles.FaireDirect.EMAIL_CAMPAIGN],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "xz2E/t",
        defaultMessage: [{
          "type": 0,
          "value": "How Faire works issue"
        }]
      })
    }
  };
};